import { render, staticRenderFns } from "./StepThree.vue?vue&type=template&id=3472f160&scoped=true&"
import script from "./StepThree.vue?vue&type=script&lang=js&"
export * from "./StepThree.vue?vue&type=script&lang=js&"
import style0 from "./StepThree.vue?vue&type=style&index=0&id=3472f160&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3472f160",
  null
  
)

export default component.exports